import { render, staticRenderFns } from "./IncomeReport.vue?vue&type=template&id=12647c9a&scoped=true&"
import script from "./IncomeReport.vue?vue&type=script&lang=js&"
export * from "./IncomeReport.vue?vue&type=script&lang=js&"
import style0 from "./IncomeReport.vue?vue&type=style&index=0&id=12647c9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12647c9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
